import React from 'react';
import {
  Mail, Sparkles, Users,
} from 'lucide-react';
import { KpiCard, LoadingSkeleton } from './_shared';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function LeadsTab({ data }) {
  if (!data) return <LoadingSkeleton />;
  const leads = Array.isArray(data) ? data : [];
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <KpiCard icon={Mail} label="Total Leads" value={leads.length} color="#3B82F6" />
        <KpiCard icon={Users} label="With HubSpot ID" value={leads.filter(l => l.hubspot_id).length} subtext="synced to CRM" color="#F97316" />
        <KpiCard icon={Sparkles} label="Sources" value={[...new Set(leads.map(l => l.source).filter(Boolean))].length} color="#8B5CF6" />
      </div>
      <div className="bg-white rounded-xl border border-gray-100 p-6">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2 mb-4">
          <Mail className="w-4 h-4 text-blue-500" /> All Leads
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-gray-400 text-xs border-b border-gray-100">
              <th className="pb-2 font-medium">Name</th><th className="pb-2 font-medium">Email</th><th className="pb-2 font-medium">Source</th><th className="pb-2 font-medium">Interests</th><th className="pb-2 font-medium">HubSpot</th><th className="pb-2 font-medium">Date</th>
            </tr></thead>
            <tbody>
              {leads.map((lead, i) => (
                <tr key={lead.email} className="border-b border-gray-50 last:border-0">
                  <td className="py-2.5 text-gray-700">{lead.first_name} {lead.last_name}</td>
                  <td className="py-2.5 text-gray-500">{lead.email}</td>
                  <td className="py-2.5"><span className="px-2 py-0.5 bg-teal-50 text-teal-600 text-xs rounded-full">{lead.source || 'website'}</span></td>
                  <td className="py-2.5 text-gray-400 text-xs">{(lead.interests || []).join(', ') || '-'}</td>
                  <td className="py-2.5">{lead.hubspot_id ? <span className="px-2 py-0.5 bg-green-50 text-green-600 text-xs rounded-full">Synced</span> : <span className="text-gray-300 text-xs">-</span>}</td>
                  <td className="py-2.5 text-gray-400 text-xs">{lead.created_at ? new Date(lead.created_at).toLocaleDateString() : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
